import { GameObjects } from "phaser";

import { GButton } from "../gameobjects/GButton";

export class PickedNumbers extends GameObjects.Container {
    constructor(scene, x, y, data) {
        super(scene, x, y);

        this.numbersArray = data.numbersArray.selectedNumbers;

        this.ticketNumber = data.ticketNumber+1;
        
        // Add this container to the scene
        scene.add.existing(this);

        this.createGrid();

        const ticketNumberText = this.scene.add.text(0, 0, `TICKET ${this.ticketNumber}`, {
            fontFamily: 'Oswald', 
            fontSize: '38px',
            color: '#fff',
        }).setOrigin(0, 0); // Set origin to top-left;
        ticketNumberText.setOrigin(0).setPadding({ left: 0,  top: 0 });
        ticketNumberText.setFontStyle('700')

        // Add the text object to this container
        this.add(ticketNumberText);


        const titleContainer = this.scene.add.container(0,0)
        // titleContainer.setSize(343*2, 100*2)
        // const background = this.scene.add.rectangle(0, 0, 320*2, 52*2, 0x000000, 0.5);
        // background.setOrigin(0, 0); // Top-left origin
        // titleContainer.add(background)
        this.add(titleContainer)
        // Call the method to create and display the text objects
     

        //const ticketPriceText = this.scene.add.text(530 , 12, `$${data.numbersArray.totalAmount}`, {
        // const ticketPriceText = this.scene.add.text(this.scene.scale.width - 108*2 , 12, `$${data.numbersArray.totalAmount}`, {
        //     fontFamily: 'Oswald', 
        //     fontSize: '20px',
        //     color: '#FFF',
        // }).setOrigin(1, 0); // Set origin to top-left;
        // ticketPriceText.setFontStyle('700')

        const bounds = this.getBounds()


        const ticketPriceText = this.scene.add.text(bounds.width - 80, 16, `$${data.numbersArray.totalAmount}`, {
            fontFamily: 'Oswald', 
            fontSize: '24px',
            color: '#FFF',
        }).setOrigin(1, 0); // Set origin to top-left;
        ticketPriceText.setFontStyle('700')

        titleContainer.add(ticketPriceText);


        const ticketCostText = this.scene.add.text(ticketPriceText.x - ticketPriceText.width -16, 16, `COST:`, {
            fontFamily: 'Oswald', 
            fontSize: '24px',
            color: '#BEBEBE',
        }).setOrigin(1, 0); // Set origin to top-left;
        ticketCostText.setFontStyle('700')

        titleContainer.add(ticketCostText);

        // console.log(ticketCostText)
        // console.log(this.getBounds())

        

        //console.log("Number container bounds", this.getBounds())

        //console.log("bounds.width", bounds.width)
        const ButtonRemoveTicket = new GButton(scene, bounds.width - 36, 30, {
            texturePack: "pack", 
            idleTexture: 'Ticket Button - Default.png',
            clickedTexture: 'Ticket Button - Clicked.png',
            disabledTexture: 'Ticket Button - Default.png',
            icon:{
                image: 'x-icon.png',
                // scale: 0.5
            },
            onClick: () => {
                //scene.scene.scene.updateTicketList() 
                scene.onSpriteClick(data.ticketNumber);
                //this.scene.onSpriteClick();
             }
        });
        ButtonRemoveTicket.setScale(1)
        titleContainer.add(ButtonRemoveTicket)


        // this.graphicsC = scene.add.graphics();
        // this.graphicsC.clear();

        // this.graphicsC.lineStyle(2, 0xff0000);
        // this.graphicsC.strokeRectShape(this.getBounds());
    }

    // Method to create and display the grid of numbers as text objects
    createGrid() {
        const columns = 6;       // Number of columns
        const textSpacingX = (40 + 16)*2 ; // Horizontal space between text objects
        const textSpacingY = (40 + 16)*2; // Vertical space between text objects

        for (let i = 0; i < this.numbersArray.length; i++) {
            const number = this.numbersArray[i];

            // Calculate the x and y position for each text object
            const x = (i % columns) * textSpacingX;
            //console.log( "const x =", (i % columns) * textSpacingX)
            const y = Math.floor(i / columns) * textSpacingY + 120;

            // Create the text object for the current number

            
            const numberCircle = this.scene.add.sprite(x, y, 'pack' ,'Lotto Number - Unselected - Default.png').setOrigin(0,0.5);
            // Add the text object to this container
            this.add(numberCircle);

            const numberText = this.scene.add.text(x+44, y, number.toString(), {
                fontFamily: 'Montserrat',
                fontSize: '30px',
                color: '#fff',
            });
            numberText.setOrigin(0.5)
            numberText.setFontStyle('700')

            // Add the text object to this container
            this.add(numberText);
        }
    }


}